import {
    CollateralResponse,
    PowersportsAssetResponse,
} from 'api/application/getCollaterals'
import AssetValuationMethodType from 'state/enums/AssetValuationMethodType'

function getAssetValuationMethod(
    collateral: CollateralResponse<PowersportsAssetResponse>,
) {
    const assetValuationMethod = !collateral.asset_valuation_method
        ? null
        : AssetValuationMethodType[
              collateral.asset_valuation_method.toUpperCase() as keyof typeof AssetValuationMethodType
          ]

    return assetValuationMethod
}

export default getAssetValuationMethod
